((Scroll, $) => {
  var bindUIActions = () => {
    $(document).on("click", "[data-smooth-scroll]", event => {
      event.preventDefault();
      const $this = $(event.currentTarget);
      const targetName = $this.attr("data-smooth-scroll");
      const $target = $(`[data-scroll-position="${targetName}"]`);
      const headerHeight = $(".site-header").outerHeight();
      const promobarHeight = $(".promo-bar").outerHeight();
      const scrollOffset = $target.offset().top - headerHeight - promobarHeight;
      $("html,body").animate({ scrollTop: scrollOffset }, 300);
    });
  };

  Scroll.init = () => {
    bindUIActions();
  };
})((window.Scroll = window.Scroll || {}), jQuery);
